let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4r7x8")).then(() => parcelRequire('68Zf7'));